define('home/templates/threadCardDefaultFooter',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<span class=\"icon-lock icon-tiny spacing-right-small\"></span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"1 Comment",{"name":"gettext","hash":{},"data":data}))
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"%(posts)s Comments",{"name":"gettext","hash":{"posts":(depth0 != null ? depth0.posts : depth0)},"data":data}))
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<li class=\"action\">\n<a href=\"#\" data-action=\"favorite\"\nclass=\"action-favorite "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.favorited : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.favorited : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<span class=\"icon icon-heart\"></span>\n</a>\n</li>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "active";
},"10":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Recommended",{"name":"gettext","hash":{},"data":data}))
    + "\n";
},"12":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Recommend",{"name":"gettext","hash":{},"data":data}))
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<ul class=\"actions\">\n<li class=\"action\">\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "\"\ndata-link-name=\"comment_count\"\ndata-thread-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.isClosed : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias3,helpers.eq.call(alias3,(depth0 != null ? depth0.posts : depth0),1,{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "<span class=\"icon icon-comment\"></span>\n</a>\n</li>\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.authenticated : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n";
},"useData":true})

});
